export const reportTemplateInitial = {
  rnd: {
    id: 0,
    name: '',
    report_template_categories: [{
      title: 'Executive Summary',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Contents',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Ayming Overview',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Company Overview',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'The Ayming UK Methodology',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Competent Professionals',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Claim Information',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Eligible R&D Projects',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }, {
      title: 'Financial Analysis',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }]
  },
  aif: {
    id: 0,
    name: '',
    report_template_categories: [{
      title: 'AIF',
      content: '',
      exclude_from_report: false,
      should_apply_styles: true
    }]
  }
};